import PropTypes from "prop-types";
import React from "react";

// TODO(etsai): We should get rid of this component once error message
//  system is organized in a consistent way.
class RawHtml extends React.PureComponent {
  static get propTypes() {
    return {
      className: PropTypes.string,
      html: PropTypes.string,
    };
  }

  render() {
    const { className, html } = this.props;
    const htmlMessage = { __html: html };

    return <span className={className} dangerouslySetInnerHTML={htmlMessage} />;
  }
}

export { RawHtml };
